import { Component } from '@angular/core';

@Component({
  selector: 'pla-data-deletion-page',
  templateUrl: './data-deletion-page.component.html',
  styleUrls: ['../legal-page/legal-page.scss']
})
export class DataDeletionPageComponent {}
